import { useTranslations } from '@vocab/react';
import { Alert, Text } from 'braid-design-system';
import { useEffect } from 'react';

import { ALERT_VIEWED } from 'src/app/shared/dataAnalytics/schema/constants';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';

import translations from './.vocab';

export const JobContentGenerationLegalDisclaimer = () => {
  const { t } = useTranslations(translations);
  const jobContentGenerationLegalDisclaimerText = t(
    'job-content-generation-legal-disclaimer-text',
  );

  useEffect(() => {
    getTrackingAdapter.sendLinkEvent({
      eventName: ALERT_VIEWED,
      alertShownMessage: jobContentGenerationLegalDisclaimerText,
      alertShownMessageCode: 'job content generation legal disclaimer',
      alertShownTone: 'informational',
    });
  }, [jobContentGenerationLegalDisclaimerText]);

  return (
    <Alert tone="info">
      <Text>{jobContentGenerationLegalDisclaimerText}</Text>
    </Alert>
  );
};
